(function () {
  // Dawn bug (stock theme code, not an R&G customization): when a variant
  // has no featured_media, ProductInfo.updateMedia() in product-info.js
  // does `if (!variantFeaturedMediaId) return;` and bails out completely -
  // it never updates which gallery slide is active, so the PREVIOUS
  // variant's photo stays on screen under the new (unrelated) scent name.
  // Confirmed live 2026-08-25: selecting "Rose Petals" (no dedicated photo)
  // right after "Orange Blossom" left the orange-tree photo showing.
  //
  // Fix: on the same variant-change event Dawn's own code publishes, if
  // the new variant has no featured_media, replace the gallery's contents
  // with the freshly-fetched section HTML Dawn already downloaded for this
  // exact change (data.html) - the server always computes the correct
  // fallback slide (the static "Candle Picture"), confirmed correct on a
  // full page load. This only intervenes in the broken case; Dawn's own
  // path is untouched when a variant does have its own photo.
  subscribe('variant-change', function (evt) {
    var data = evt && evt.data;
    if (!data || !data.sectionId || !data.html) return;
    var variant = data.variant;
    if (variant && variant.featured_media) return;

    // Mirrors Dawn's own product-info.js updateMedia() reconciliation
    // (add/remove/reorder li[data-media-id] items, then setActiveMedia)
    // rather than replacing DOM wholesale - a full innerHTML swap broke
    // the *next* native Dawn update by destroying node references Dawn's
    // own code holds onto. This only fills in the one step Dawn's code
    // skips when featured_media is null: computing which slide should be
    // active from the freshly-fetched HTML, since there's no variant id
    // to hand it.
    var root = document.querySelector('media-gallery#MediaGallery-' + data.sectionId);
    var mediaGallerySource = root && root.querySelector('ul');
    var freshRoot = data.html.getElementById('MediaGallery-' + data.sectionId);
    var mediaGalleryDestination = freshRoot && freshRoot.querySelector('ul');
    if (!root || !mediaGallerySource || !mediaGalleryDestination) return;

    var sourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
    var sourceSet = new Set(sourceItems.map(function (i) { return i.dataset.mediaId; }));
    var destItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
    var destSet = new Set(destItems.map(function (i) { return i.dataset.mediaId; }));

    for (var i = destItems.length - 1; i >= 0; i--) {
      if (!sourceSet.has(destItems[i].dataset.mediaId)) {
        mediaGallerySource.prepend(destItems[i]);
      }
    }
    for (var j = 0; j < sourceItems.length; j++) {
      if (!destSet.has(sourceItems[j].dataset.mediaId)) {
        sourceItems[j].remove();
      }
    }

    var activeDest = mediaGalleryDestination.querySelector('li[data-media-id].is-active');
    var activeId = activeDest && activeDest.dataset.mediaId;
    if (activeId && root.setActiveMedia) root.setActiveMedia(activeId, true);
  });
})();


(function () {
  // Real gap found during Strategist code review, 2026-08-29: the variant
  // scent-image pilot (custom.scent_image metafield) adds a gallery slide
  // AND thumbnail whose IDENTITY genuinely changes between variants -
  // unlike everything else in this theme, where product.media's full
  // membership never changed across variants of the same product (only
  // which single item was "active" ever did). Confirmed by reading
  // product-info.js, media-gallery.js, and this file in full: none of
  // them ever add/remove a thumbnail-list item on variant change, only
  // the main slider's <ul>. This block is the thumbnail-list equivalent
  // of product-info.js's own updateMedia() reconciliation, reusing its
  // exact three-phase algorithm (add missing -> remove extra -> reorder
  // to match the freshly-rendered order) rather than inventing a new one.
  //
  // First draft of this fix (review round 1) had three real bugs, all
  // found by code review before deployment, none guessed at by Jarvis:
  //  1. [id^="GalleryThumbnails"] selects the outer <slider-component>
  //     wrapper, not the nested <ul> the <li> items actually live in -
  //     confirmed by reading the section markup directly. Fixed by
  //     querying .querySelector("ul") inside that wrapper, same pattern
  //     the main-gallery fix above already uses on media-gallery itself.
  //  2. Prepending every new item loses the server's real order. Fixed by
  //     porting product-info.js's exact reorder-by-destination-index step.
  //  3. media-gallery.js binds thumbnail click listeners once, per-node,
  //     in its constructor (confirmed by reading the file) - it never
  //     re-scans for new nodes. A thumbnail inserted by this script after
  //     page load would be inert until explicitly given the same listener
  //     here.
  //  Also handled: slider-component.resetPages() (confirmed to exist on
  //  every slider-component instance via global.js) re-queries its slide
  //  list for pagination/control state - never called for the thumbnail
  //  slider by any existing code, since membership never changed before.
  //  Called here whenever an item was actually added or removed, matching
  //  when Dawn's own equivalent flag (shouldRefresh) would fire.
  //
  // Disclosed limitation: this section's live gallery_layout setting is
  // currently "stacked", under which the thumbnail strip does not render
  // at all (confirmed live, zero GalleryThumbnails markup on the page
  // today) - so this fix is currently inert in production and cannot be
  // interactively click-tested against a real rendered thumbnail strip
  // without either a browser tool (not available this session) or
  // changing the live gallery_layout setting (a separate, visible
  // storefront change not authorized here). Verified instead by tracing
  // every mechanism against the real, already-proven code it mirrors.
  subscribe('variant-change', function (evt) {
    var data = evt && evt.data;
    if (!data || !data.sectionId || !data.html) return;

    var root = document.querySelector('media-gallery#MediaGallery-' + data.sectionId);
    var thumbsWrapper = root && root.querySelector('[id^="GalleryThumbnails"]');
    var thumbSource = thumbsWrapper && thumbsWrapper.querySelector('ul');
    var freshRoot = data.html.getElementById('MediaGallery-' + data.sectionId);
    var freshThumbsWrapper = freshRoot && freshRoot.querySelector('[id^="GalleryThumbnails"]');
    var thumbDestination = freshThumbsWrapper && freshThumbsWrapper.querySelector('ul');
    if (!thumbSource || !thumbDestination) return;

    function refreshSourceData() {
      var items = Array.from(thumbSource.querySelectorAll('li[data-target]'));
      var set = new Set(items.map(function (i) { return i.dataset.target; }));
      var map = new Map(
        items.map(function (item, index) { return [item.dataset.target, { item: item, index: index }]; })
      );
      return [items, set, map];
    }

    function bindThumbnailClick(item) {
      var button = item.querySelector('button');
      if (!button) return;
      button.addEventListener('click', function () {
        if (root.setActiveMedia) root.setActiveMedia(item.dataset.target, false);
      });
    }

    var refreshed = refreshSourceData();
    var sourceItems = refreshed[0];
    var sourceSet = refreshed[1];
    var sourceMap = refreshed[2];
    var destItems = Array.from(thumbDestination.querySelectorAll('li[data-target]'));
    var destSet = new Set(destItems.map(function (i) { return i.dataset.target; }));
    var shouldRefresh = false;

    // add items from fresh render not present in the live DOM - bind a
    // click listener on each, since the constructor's one-time binding
    // (media-gallery.js) never sees nodes inserted after page load
    for (var i = destItems.length - 1; i >= 0; i--) {
      if (!sourceSet.has(destItems[i].dataset.target)) {
        var newItem = destItems[i];
        thumbSource.prepend(newItem);
        bindThumbnailClick(newItem);
        shouldRefresh = true;
      }
    }

    // remove items from the live DOM not present in the fresh render
    for (var j = 0; j < sourceItems.length; j++) {
      if (!destSet.has(sourceItems[j].dataset.target)) {
        sourceItems[j].remove();
        shouldRefresh = true;
      }
    }

    if (shouldRefresh) {
      refreshed = refreshSourceData();
      sourceItems = refreshed[0];
      sourceSet = refreshed[1];
      sourceMap = refreshed[2];
    }

    // reorder to match the freshly-rendered order - identical technique to
    // product-info.js's own updateMedia(), applied to the thumbnail list
    destItems.forEach(function (destinationItem, destinationIndex) {
      var sourceData = sourceMap.get(destinationItem.dataset.target);
      if (sourceData && sourceData.index !== destinationIndex) {
        thumbSource.insertBefore(
          sourceData.item,
          thumbSource.querySelector('li:nth-of-type(' + (destinationIndex + 1) + ')')
        );
        var refreshedAgain = refreshSourceData();
        sourceItems = refreshedAgain[0];
        sourceSet = refreshedAgain[1];
        sourceMap = refreshedAgain[2];
      }
    });

    if (shouldRefresh && thumbsWrapper.resetPages) thumbsWrapper.resetPages();
  });
})();
